(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["us-prelaunch-klaviyo-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-us-prelaunch-klaviyo-guard]');
  if (!marker) return;

  const legacyFormId = 'S4AiNv';
  const allowedFormId = marker.dataset.usPrelaunchKlaviyoAllowedForm || '';

  const selectors = [
    `.klaviyo-form-${legacyFormId}`,
    `[data-form-id="${legacyFormId}"]`,
    `[data-testid*="${legacyFormId}"]`,
    `[id*="${legacyFormId}"]`,
    `[class*="${legacyFormId}"]`
  ];

  const containsAllowedForm = (node) => {
    if (!(node instanceof Element) || !allowedFormId) return false;
    const allowedSelectors = [
      `.klaviyo-form-${allowedFormId}`,
      `[data-form-id="${allowedFormId}"]`,
      `[data-testid*="${allowedFormId}"]`,
      `[id*="${allowedFormId}"]`,
      `[class*="${allowedFormId}"]`
    ];
    return allowedSelectors.some((selector) => node.matches(selector) || node.querySelector(selector));
  };

  const suppressLegacyNode = (node) => {
    if (!(node instanceof Element) || containsAllowedForm(node)) return;

    const dialog = node.closest('[role="dialog"]');
    const container = dialog && !containsAllowedForm(dialog) ? dialog : node;

    container.style.setProperty('display', 'none', 'important');
    container.style.setProperty('visibility', 'hidden', 'important');
    container.style.setProperty('pointer-events', 'none', 'important');
    container.setAttribute('aria-hidden', 'true');
  };

  const suppressLegacyForm = (root = document) => {
    selectors.forEach((selector) => {
      if (root instanceof Element && root.matches(selector)) suppressLegacyNode(root);
      root.querySelectorAll?.(selector).forEach(suppressLegacyNode);
    });
  };

  suppressLegacyForm();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) suppressLegacyForm(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["us-retail-locator"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('us-retail-locator');
  if (!dialog) return;

  const apiBase = 'https://focused-transformation-production-ecde.up.railway.app';
  const overviewBox = { x: 0, y: 0, width: 959, height: 593 };
  let storePromise;

  const fetchStores = () => {
    if (!storePromise) {
      storePromise = fetch(`${apiBase}/stores`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Store data unavailable');
          return response.json();
        })
        .then((payload) => Array.isArray(payload.stores) ? payload.stores : []);
    }
    return storePromise;
  };

  const fetchZip = async (zip) => {
    const response = await fetch(`${apiBase}/zip/${encodeURIComponent(zip)}`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('ZIP code not found');
    return response.json();
  };

  const milesBetween = (a, b) => {
    const toRad = (degrees) => degrees * Math.PI / 180;
    const earthRadius = 3958.8;
    const dLat = toRad(b.lat - a.lat);
    const dLon = toRad(b.lon - a.lon);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    return earthRadius * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  };

  const projectLower48 = ({ lat, lon }) => {
    const radians = (degrees) => degrees * Math.PI / 180;
    const phi1 = radians(29.5);
    const phi2 = radians(45.5);
    const phi0 = radians(38);
    const lambda0 = radians(-96);
    const n = .5 * (Math.sin(phi1) + Math.sin(phi2));
    const c = Math.cos(phi1) ** 2 + 2 * n * Math.sin(phi1);
    const rho0 = Math.sqrt(c - 2 * n * Math.sin(phi0)) / n;
    const phi = radians(lat);
    const theta = n * (radians(lon) - lambda0);
    const rho = Math.sqrt(c - 2 * n * Math.sin(phi)) / n;
    const px = rho * Math.sin(theta);
    const py = rho0 - rho * Math.cos(theta);
    return {
      x: 70 + ((px + .47) / .94) * 830,
      y: 540 - ((py + .17) / .43) * 480
    };
  };

  const project = (location, state) => {
    if (state === 'AK') {
      const x = 85 + ((location.lon + 170) / 40) * 195;
      const y = 505 - ((location.lat - 52) / 20) * 105;
      return { x, y };
    }
    if (state === 'HI') {
      const x = 300 + ((location.lon + 161) / 7) * 145;
      const y = 525 - ((location.lat - 18.5) / 4) * 70;
      return { x, y };
    }
    return projectLower48(location);
  };

  const formatAddress = (address) => {
    if (!address) return '';
    const cityLine = [address.city, address.state, address.postal_code].filter(Boolean).join(' ');
    return [address.street, cityLine].filter(Boolean).join(', ');
  };

  const setViewBox = (svg, box) => {
    svg.setAttribute('viewBox', `${box.x} ${box.y} ${box.width} ${box.height}`);
  };

  const fitPoints = (svg, points) => {
    if (!points.length) {
      setViewBox(svg, overviewBox);
      return;
    }
    const xs = points.map((point) => point.x);
    const ys = points.map((point) => point.y);
    let minX = Math.min(...xs);
    let maxX = Math.max(...xs);
    let minY = Math.min(...ys);
    let maxY = Math.max(...ys);
    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;
    const spanX = Math.max(maxX - minX, 85);
    const spanY = Math.max(maxY - minY, 65);
    const aspect = 959 / 593;
    let width = Math.max(spanX * 2.15, spanY * 2.15 * aspect);
    width = Math.min(width, 520);
    const height = width / aspect;
    minX = Math.max(0, Math.min(959 - width, centerX - width / 2));
    minY = Math.max(0, Math.min(593 - height, centerY - height / 2));
    setViewBox(svg, { x: minX, y: minY, width, height });
  };

  const form = dialog.querySelector('[data-us-retail-form]');
  const submitButton = form?.querySelector('button[type="submit"]');
  const error = dialog.querySelector('[data-us-retail-error]');
  const results = dialog.querySelector('[data-us-retail-results]');
  const resultsZip = dialog.querySelector('[data-us-retail-results-zip]');
  const resultsList = dialog.querySelector('[data-us-retail-results-list]');
  const map = dialog.querySelector('[data-us-retail-map]');
  const pins = dialog.querySelector('[data-us-retail-map-pins]');

  const resetMap = () => {
    pins?.replaceChildren();
    if (map) setViewBox(map, overviewBox);
  };

  dialog.querySelector('[data-us-retail-locator-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', resetMap);

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const zip = String(new FormData(form).get('zip') || '').trim();
    const valid = /^\d{5}$/.test(zip);
    error.hidden = valid;
    if (!valid) {
      results.hidden = true;
      resetMap();
      return;
    }

    submitButton?.setAttribute('disabled', 'disabled');

    try {
      const [origin, stores] = await Promise.all([fetchZip(zip), fetchStores()]);
      const nearest = stores
        .filter((store) => store.coordinates && Number.isFinite(store.coordinates.lat) && Number.isFinite(store.coordinates.lon))
        .map((store) => ({
          ...store,
          lat: store.coordinates.lat,
          lon: store.coordinates.lon,
          distance: milesBetween(origin, store.coordinates)
        }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 4);

      error.hidden = true;
      resultsZip.textContent = zip;
      resultsList.replaceChildren();
      pins.replaceChildren();

      const mapPoints = [];

      nearest.forEach((store, index) => {
        const item = document.createElement('li');
        item.className = 'us-retail-locator__result';

        const number = document.createElement('span');
        number.className = 'us-retail-locator__result-number';
        number.textContent = String(index + 1);

        const details = document.createElement('div');
        const name = document.createElement('span');
        name.className = 'us-retail-locator__result-name';
        name.textContent = store.name;
        const address = document.createElement('span');
        address.className = 'us-retail-locator__result-address';
        address.textContent = formatAddress(store.address);
        details.append(name, address);

        if (store.phone) {
          const phone = document.createElement('a');
          phone.className = 'us-retail-locator__result-link';
          phone.href = `tel:${store.phone.replace(/[^+\d]/g, '')}`;
          phone.textContent = store.phone;
          details.append(phone);
        }

        if (store.website) {
          const website = document.createElement('a');
          website.className = 'us-retail-locator__result-link';
          website.href = store.website;
          website.target = '_blank';
          website.rel = 'noopener';
          website.textContent = store.website.replace(/^https?:\/\//, '').replace(/\/$/, '');
          details.append(website);
        }

        const distance = document.createElement('span');
        distance.className = 'us-retail-locator__result-distance';
        distance.textContent = `${Math.round(store.distance)} mi`;

        item.append(number, details, distance);
        resultsList.append(item);

        const state = String(store.address?.state || origin.state || '').toUpperCase();
        const point = project(store, state);
        mapPoints.push(point);

        const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        const pin = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        pin.setAttribute('cx', point.x.toFixed(1));
        pin.setAttribute('cy', point.y.toFixed(1));
        pin.setAttribute('r', '13');
        pin.setAttribute('class', 'us-retail-locator__map-pin');
        const label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        label.setAttribute('x', point.x.toFixed(1));
        label.setAttribute('y', point.y.toFixed(1));
        label.setAttribute('class', 'us-retail-locator__map-pin-label');
        label.textContent = String(index + 1);
        group.append(pin, label);
        pins.append(group);
      });

      if (map) fitPoints(map, mapPoints);
      results.hidden = false;
    } catch (fetchError) {
      error.hidden = false;
      results.hidden = true;
      resetMap();
    } finally {
      submitButton?.removeAttribute('disabled');
    }
  });

  resetMap();
  fetchStores().catch(() => {});
})();
  } catch(e) { console.error(e); }
})();

})();
